import { isUserSubscribedToChannel } from "../utils/subscriptionUtils";
import { getMultiTaggedAddOnContent } from "../utils/addOnsUtil";
import { i18n } from "../services/i18nService";
import { resolution } from "../config/ui/resolutionConfig";
import { isAVODContent, isSVODContent, isTVODContent, isADMNContent, isADMNRoute } from "./tvodUtils";
import { isFVODFreeToAir } from "./fvodUtils";
import { getAppState } from "../state";

const CW = "cw";
const WATCHLIST = "watchlist";
const PLAY = "playOnDetailsFocused";
const LISTLIVECHANNELS = "LiveChannels";
const LOCK = "lock";
const STORE = "store";
const FREETV = "freetv";
const PREMIUM = "premium";
const ADMN = "admn";
const ADMN_URL = "/images/free/ADMN-tag.svg";

export default function getTitlesFormattedForCarousels(type = "", titles = [], modules = null) {
  const customHeight =
    type === "LiveChannels" && this.state.nameSection !== "live"
      ? resolution.carousel.height?.home?.live
      : type === "LiveChannels" && this.state.nameSection === "live"
      ? resolution.carousel.height?.live?.live
      : false;
  const customWidth =
    type === "LiveChannels" && this.state.nameSection !== "live"
      ? resolution.carousel.width?.home?.live
      : type === "LiveChannels" && this.state.nameSection === "live"
      ? resolution.carousel.width?.live?.live
      : false;

  const liveStatusIconText = type === "LiveChannels" && i18n.get("pages.livePage.liveCarousel.live");
  const titlesModified = JSON.parse(JSON.stringify(titles));
  const carouselType = type.toLowerCase();
  const isCWCarousel = carouselType === CW || carouselType === WATCHLIST;
  const isListLiveChannels = carouselType === LISTLIVECHANNELS.toLowerCase();
  titlesModified.forEach(title => {
    const { assetTypes } = title;
    if (isCWCarousel) {
      title.iconOverlay = PLAY;
    }
    if (customHeight) {
      title.customHeight = customHeight;
    }
    if (customWidth) {
      title.customWidth = customWidth;
    }
    if (liveStatusIconText) {
      title.liveStatusIconText = liveStatusIconText;
    }
    if (title) {
      title.hasFrenchAudio = title?.hasFrenchAudio ? title?.hasFrenchAudio : getHasFrenchAudio(title);
    }
    if (isListLiveChannels) {
      getFormatedNextProgram(title);
    }
    if (assetTypes && assetTypes.length > 0) {
      getContentType.call(this, title, isCWCarousel);
    }
    const isADMN = isADMNContent(title?.contentOwnership);
    const showBadgeFromStyle = !!(modules?.style?.showBadges?.admn || title?.style?.showBadges?.admn);
    const shouldShowAdmn = isADMN && (modules?.isADMNBadgeEnabled || showBadgeFromStyle);

    if (isADMNRoute(this.props.location.pathname)) {
      title.badges = [];
      title.text = "";
      title.admnIcon = "";
      title.icon = "";
    } else if (modules && modules.category === "List5CW") {
      title.admnIcon = "";
    } else if (shouldShowAdmn) {
      title.admnIcon = ADMN_URL;
      title.icon = "";
    }
  });
  return titlesModified;
}

/* Formatting Live carousel Next program */
const getFormatedNextProgram = title => {
  const next = title.next;
  if (next) {
    next.tsStart = getTime(next);
    next.headingTitle = i18n.get("pages.livePage.liveCarousel.upnext");
    title.next = next;
  }
  return title;
};

const getTime = programme => {
  const startTime = new Date(programme.tsStart * 1000);
  let minutes = new Date(startTime).getMinutes();
  minutes = minutes <= 9 ? "0" + minutes : minutes;
  return `${new Date(startTime).getHours()}:${minutes}`;
};

/**
 *
 * @param {Object} title
 * @returns It adds the additional properties in title object and return the modified title data.
 */
function getContentType(title, isCWCarousel) {
  const {
    name: pageName,
    applicationState: { userLogged, addons, isSvodUser }
  } = this.props;
  const { assetTypes, badges, freeToAir } = title;
  let isAVOD = isAVODContent(assetTypes);
  let isSVOD = isSVODContent(assetTypes);
  let isTVOD = isTVODContent(assetTypes);

  const isFreeEpisode = freeToAir === true ? true : isFVODFreeToAir(title.tags);
  if (isFreeEpisode && !isCWCarousel && isSVOD && !isSvodUser) {
    const badge = badges && badges.length > 0 && badges[0];
    title.text = badge || "";
  } else if (isAVOD && pageName?.toLowerCase() !== FREETV && !isSvodUser) {
    const badge = badges && badges.length > 0 && badges[0];
    title.text = badge || "";
  } else if (isSVOD) {
    if (isFreeEpisode) {
      // do nothing
    } else {
      getIcon.call(this, title, userLogged, addons);
    }
  } else if (isTVOD && pageName?.toLowerCase() !== STORE) {
    title.icon = STORE;
  }
  return title;
}

function getIcon(title, userLogged, addons) {
  if (userLogged) {
    const IconTitle = title;
    let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, title.addonContent, title.subscription);

    const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
      this,
      isUserSubscribedToAsset,
      title.addonContent,
      title.subscriptionPerCountry
    );
    isUserSubscribedToAsset = isUserSubscribedToChannel(addons, multiTaggedAddOnContent, title.subscription);

    if (!isUserSubscribedToAsset) {
      IconTitle.icon = LOCK;
    }
    return IconTitle;
  } else {
    title.icon = LOCK;
    return title;
  }
}
const getHasFrenchAudio = title => {
  if (title?.hasFrenchAudio) return true;
  if (title?.languages === null || !title?.languages?.length) return false;

  let language = title.languages.includes("fr") || title.languages.includes("French");
  return title?.languages[0] === "fr" || title?.languages[0] === "French" || language ? true : false;
};
